import { createContext, useContext } from 'react';

import { type AdminAccess, NO_ACCESS } from '@/lib/platformAdmin';

/**
 * What the signed-in user may do, resolved once by the app gate. Read it here
 * rather than from `useAuth()`: each `useAuth()` resolves its own token, so a
 * fresh one reads "no access" for a render and would bounce an admin.
 */
export const AdminAccessContext = createContext<AdminAccess>(NO_ACCESS);

export function useAdminAccess(): AdminAccess {
  return useContext(AdminAccessContext);
}
